// Cor da barra de status no app instalado: o iPhone pinta a faixa de cima com a theme-color e esfuma até a tela. Com
// uma cor só, o topo verde do Início ficava com uma névoa clara em cima. Verde quando o topo da tela é o degradê
// (entrada, boas-vindas, Início antes de rolar); clara na abertura e nas outras telas.
import { aberturaFechada } from "@/lib/abertura";

export const COR_DA_BARRA = {
  /** O verde do alto do degradê (.app-heroi, oklch(0.45 0.058 160)). */
  verde: "#3a604c",
  /** O fundo do app (--background no [data-app]). */
  clara: "#f2f5f3",
} as const;

type Cor = keyof typeof COR_DA_BARRA;

/** A última cor que uma tela pediu. Enquanto a abertura (clara) está na frente, ela espera. */
let pedida: Cor = "clara";

function pintar(cor: Cor): void {
  if (typeof document === "undefined") return;
  document
    .querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')
    .forEach((meta) => meta.setAttribute("content", COR_DA_BARRA[cor]));
}

export function corDaBarraDeStatus(cor: Cor): void {
  pedida = cor;
  if (aberturaFechada()) pintar(cor);
}

/** Quando a abertura some: entra a cor que a tela de baixo pediu. */
export function aplicarCorPedida(): void {
  pintar(pedida);
}
